// upsell types
export const NORMAL_OFFER = 'normal';
export const BUNDLE_OFFER = 'bundle';
export const VOLUME_DISCOUNT_OFFER = 'volume_discount';
export const FBT_OFFER = 'fbt';
